const SELECTOR = '[data-scroll-reveal]';
const REVEALED_CLASS = 'is-revealed';

/**
 * @param {NodeListOf<Element> | Element[]} elements
 */
function revealAll(elements) {
  for (const element of elements) {
    element.classList.add(REVEALED_CLASS);
  }
}

function init() {
  const elements = document.querySelectorAll(SELECTOR);
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    revealAll(elements);
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(REVEALED_CLASS);
        obs.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.1 }
  );

  for (const element of elements) {
    observer.observe(element);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
